import * as Roles from '@/store/roles';

export const undoActionsPermissions = {
  clearUndo: [Roles.Any],
  undo: [Roles.Any],
  redo: [Roles.Any],
};



// WEBPACK FOOTER //
// ./src/store/undo/undoActionsPermissions.js